import Requests from "../../../../services/requests";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MenuLateral from "../../../../components/menu-lateral";
import MenuHeader from "../../../../components/menu-header";
import "./styles/mascaraInfo.css";

export function MascaraInfo({ token }) {
    let config = { headers: { "x-access-token": token } };
    let { id } = useParams();

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        async function fetchData() {
            try {
                await Requests.getAllMascaraFugaById(id, config).then((res) => {
                    setData(res);
                });
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, []);

    if (isLoading) {
        return (
            <div className="loading">
                <p>Loading...</p>
            </div>
        );
    }

    const formatDate = (date) => {
        const dataBanco = new Date(date);
        const dataFormatada = dataBanco.toLocaleDateString();
        return dataFormatada;
    };

    return (
        <div>
            <div className="container-mascara">
                <header className="menu-header">
                    <MenuHeader />
                </header>
                <div className="menu-lateral-wrapper">
                    <MenuLateral />
                </div>
                <div className="title-container">
                    <h1 className="title">Inspeção mascara de fuga</h1>
                </div>
                {data.map((check, i) => {
                    return (
                        <main className="datagrid-container">
                            <div className="table-content">
                                <div key={i}>
                                    <thead>
                                        <tr>
                                            <th>Empresa</th>
                                            <th>Local</th>
                                            <th>Data da ultima inspeção</th>
                                            <th>Numero de Pessoas</th>
                                            <th>Quantidade necessária de máscaras</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <td>{check.nm_empresa ? check.nm_empresa : "Não informado"}</td>
                                        <td>{check.ds_local ? check.ds_local : "Não informado"}</td>
                                        <td>{check.dt_ultima_inspe ? formatDate(check.dt_ultima_inspe) :  "Não informado"}</td>
                                        <td>{check.nr_pessoas ? check.nr_pessoas : "Não informado"}</td>
                                        <td>{check.ds_qtde_necessaria ? check.ds_qtde_necessaria : "Não informado"}</td>
                                    </tbody>
                                </div>
                                <br></br>
                                <br></br>
                                <div key={i}>
                                    <thead>
                                        <tr>
                                            <th>Quantidade existente de máscaras</th>
                                            <th>Vencimento de filtros</th>
                                            <th>Mascaras em boas condições?</th>
                                            <th>Quantidade de máscaras faltantes</th>
                                            <th>Responsável id</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <td>{check.ds_qtde_existente ? check.ds_qtde_existente : "Não informado"}</td>
                                        <td>{check.ds_filtros_venc ? check.ds_filtros_venc :  "Não informado"}</td>
                                        <td>{check.ds_mas_condicoes ? check.ds_mas_condicoes : "Não informado"}</td>
                                        <td>{check.ds_qtde_faltante ? check.ds_qtde_faltante : "Não informado"}</td>
                                        <td>{check.id_usuario ? check.id_usuario : "Não informado"}</td>
                                    </tbody>
                                </div>
                            </div>
                        </main>
                    );
                })}
            </div>
        </div>
    );
}
